import { isDesktop } from "react-device-detect";

//styles
import './css/Custom.css';

//common
import Header from './components/common/Header';

//ads
import LateralIzquierdo from './ads/LateralIzquierdo';
import LateralDerecho from './ads/LateralDerecho';
import Caja3 from './ads/Caja3';
import Zocalo from './ads/Zocalo';

//components
import Home from './components/home/Home';
import BackgroundImage from './components/common/BackgroundImage';
import EmptySpace from './components/common/EmptySpace';

//constants
import { socialShareText, urlAssets } from './Constants';

const App = () => {

    return (
        <>
            <Header />
            <main className="position-relative container cont-principal px-0">
                <BackgroundImage alt={socialShareText} isDesktop={isDesktop} urlAssets={urlAssets} />
                {isDesktop && <LateralIzquierdo />} 
                <section className="position-absolute start-50 translate-middle-x w-100 cont-layout container-titular">
                    <Home />
                    {!isDesktop && <Caja3 />}        
                    <EmptySpace />
                    <section className="content-msgs">
                        <Zocalo isDesktop={isDesktop} />
                    </section>   
                </section>
                {isDesktop && <LateralDerecho />}    
            </main>
        </>
    )
}

export default App;
